import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzDialog } from '../../../../ui/gzDialog/component/GzDialog';
import { translateFn } from '../../../../utils/translator.helper';
import { GzRemoveFromIsolationTaskWebComponent } from './gzRemoveFromIsolationTask';
import { CreateTaskRequest } from '../../types';
import { TaskType } from '../../../../tasks/networkTasks/types';
import { RemoveFromIsolationEndpointTaskSpecifics } from './types';

export class RemoveFromIsolationPopUp extends NetworkBasePopUp<GzRemoveFromIsolationTaskWebComponent> {
  protected extraDialogConfigs: Partial<GzDialog>;
  protected title = translateFn('Remove endpoint from isolation');
  protected transformToTaskTarget = true;

  protected customSetup(): void {
    this.popUpContent = new GzRemoveFromIsolationTaskWebComponent();
  }

  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    if (!this.data.targets) {
      throw new Error('Targets are not defined');
    }

    const endpointId = this.data.targets[0].specifics.endpointId;

    if (!endpointId) {
      throw new Error(`EndpointId is not defined for protected entity ${this.data.targets[0]._id}`);
    }

    const request: CreateTaskRequest<RemoveFromIsolationEndpointTaskSpecifics> = {
      settings: {
        specifics: {
          endpointId: endpointId,
          isolate: false,
        },
        taskName: this.getTaskName(),
        targets: this.data.targets,
        type: TaskType.TASK_TYPE_RESTORE_ENDPOINT_PARENT,
      },
    };

    await this.createTask<RemoveFromIsolationEndpointTaskSpecifics>(request);
  }

  private getTaskName(): string {
    return translateFn('Remove endpoint from isolation {date}', { date: new Date().toISOString().split('T')[0] });
  }
}
